import type { RouteObject } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import CategoryPage from '../pages/category/page';
import DetailPage from '../pages/detail/page';
import SearchPage from '../pages/search/page';
import AboutPage from '../pages/about/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/category/:league',
    element: (
      <SiteLayout>
        <CategoryPage />
      </SiteLayout>
    ),
  },
  {
    path: '/detail/:matchId',
    element: <DetailPage />,
  },
  {
    path: '/search',
    element: (
      <SiteLayout>
        <SearchPage />
      </SiteLayout>
    ),
  },
  {
    path: '/about',
    element: (
      <SiteLayout>
        <AboutPage />
      </SiteLayout>
    ),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;